import type { I18nDict } from '../en/common';

const zh: I18nDict = {
  // App
  appName: 'NanoImage2',
  appSlogan: '输入一句话，立即生成图片',

  // BottomNav
  nav_home: '首页',
  nav_generate: '生图',
  nav_profile: '我的',

  // Home
  home_hotTemplates: '热门模板',
  home_slideMore: '滑动查看更多',
  home_showcase: '精选作品',
  home_aiGenerated: 'AI 生成',
  home_newUserBenefit: '新用户专属福利',
  home_login: '登录',
  home_openMembership: '开通会员',
  home_vipActive: 'VIP',
  home_vip: 'VIP',
  home_aiCardDesc: '支持多种风格 · 高清无水印',
  home_activityTemplates: '活动模板',
  home_recentWorks: '最近作品',
  home_viewMore: '查看更多',
  home_templateCategories: '模板分类',
  home_noRecentWorks: '暂无最近作品',

  // Generate
  gen_title: 'AI 生图',
  gen_describeScene: '描述你的画面',
  gen_placeholder: '描述你想生成的画面，例如：一位穿着汉服的女子站在樱花树下，花瓣飘落，梦幻光晕...',
  gen_clear: '清空',
  gen_reference: '参考图',
  gen_template: '模板',
  gen_style: '风格',
  gen_ratio: '比例',
  gen_aiHelp: 'AI 帮写',
  gen_generate: '生成图片',
  gen_generating: '生成中...',
  gen_pointsCost: '每次消耗 {{cost}} 积分',
  gen_pointsCostThisTime: '本次',
  gen_pointsLeft: '剩余',
  gen_points: '积分',
  gen_aiCreating: 'AI 正在创作中',
  gen_aiCreatingDesc: '根据你的描述绘制专属画面...',
  gen_highQuality: '高质量图片生成中，请稍候...',
  gen_result: '生成结果',
  gen_success: '生成成功',
  gen_inspiration: '灵感提示',
  gen_selectStyle: '选择风格',
  gen_selectTemplate: '选择模板',
  gen_selectRatio: '选择比例',
  gen_vipUnlock: '开通会员解锁全部风格',
  gen_sdDownload: '标清下载',
  gen_hdDownload: '高清下载',
  gen_regenerate: '再来一组',
  gen_promptLabel: '生成描述',
  gen_hdNeedVip: '高清下载需会员',
  gen_hdNeedVipDesc: '开通会员即可下载高清无水印图片，享受更多专属权益',
  gen_cancel: '取消',
  gen_openMembership: '开通会员',
  gen_firstGenTitle: '生成成功！',
  gen_firstGenDesc: '你的第一张 AI 作品已诞生',
  gen_firstGenBenefits: '开通会员，解锁更多权益',
  gen_benefit1: '无限次高清下载',
  gen_benefit2: '专属 VIP 风格',
  gen_benefit3: '每日 10 次 AI 帮写',
  gen_benefit4: '优先生成通道',
  gen_continue: '继续体验',
  gen_retry: '重试',
  gen_generationCancelled: '已取消生成',
  gen_pointsInsufficient: '积分不足',
  gen_pointsInsufficientDesc: '每次生成消耗 {{cost}} 积分，你的积分余额不足。开通会员可享无限次生成！',
  gen_uploadReference: '上传参考图',
  gen_referenceDesc: '上传参考图，AI 将参考其风格生成',
  gen_removeReference: '移除参考图',
  gen_aiHelpExhausted: 'AI帮写次数已用完',
  gen_aiHelpFailed: 'AI帮写失败，请稍后重试',
  gen_contentViolation: '内容违规，请修改描述后重试',
  gen_saveSuccess: '已保存到相册',
  gen_genFailed: '生成失败，请重试',
  gen_capacityFullMessage: '当前已有 {{active}}/{{limit}} 张生成中，完成后可继续提交',
  gen_capacityIndicator: '{{active}}/{{limit}} 任务',
  gen_capacityNotSubmitted: '任务未提交：并发容量已满，已有任务完成后可再次发送',
  gen_submitNotAccepted: '任务未提交，请检查后重试',
  gen_pricingConfigUpdated: '积分配置已更新，请确认最新积分后重新提交',
  gen_pricingConfigRefreshFailed: '积分配置刷新失败，本次任务未提交，请稍后重试',
  gen_submissionConfirming: '正在确认任务是否已提交，请勿重复发送',
  gen_genTimeout: '生成超时，请重试',
  gen_referenceUploadFailed: '参考图上传失败，请重试',
  gen_referenceTooLarge: '图片过大，请选择较小的图片',
  gen_useTemplate: '使用此模板',
  gen_loginTitle: '登录后开始创作',
  gen_loginDesc: '登录即可使用 AI 生图、保存历史记录\n和享受会员专属权益',
  gen_loginBtn: '立即登录',

  // Phase 2 — model & quality selector
  gen_model: '模型',
  gen_modelLabel: '选择模型',
  gen_quality: '质量',
  gen_quality_standard: '标准',
  gen_quality_hd: '高清',
  gen_quality_ultra: '超高清',
  gen_quality_ultraVipOnly: '超高清仅 VIP 可用',
  gen_quality_ultraVipDesc: '开通会员解锁超高清生成权益',
  gen_quality_ultraVipBtn: '升级 VIP',
  gen_recommended: '推荐',
  gen_model_cost: '本次消耗 {{cost}} 积分',
  gen_pixels: '像素',

  // Quality selector names and descriptions
  gen_quality_standard_name: '普通画质',
  gen_quality_standard_desc: '标准清晰度，快速生成',
  gen_quality_hd_name: '高画质',
  gen_quality_hd_desc: '更高清晰度，细节更丰富',
  gen_quality_ultra_name: '极高画质',
  gen_quality_ultra_desc: '最高清晰度，极致细节（VIP专属）',

  // Phase 2 — recent usage modal
  gen_recentTitle: '最近使用',
  gen_noRecent: '暂无最近记录',
  gen_clickToRefill: '点击回填参数',

  // Phase 2 — 8-state task status
  gen_status_created: '任务已创建',
  gen_status_queued: '排队中…',
  gen_status_generating: 'AI 创作中…',
  gen_status_auditing: '内容审核中…',
  gen_status_success: '生成成功',
  gen_status_failed: '生成失败',
  gen_status_blocked: '内容被拦截',
  gen_status_timeout: '生成超时',
  gen_status_cancelled: '已取消',
  gen_status_refunded: '已退款',

  // Phase 2 — reason codes
  gen_reason_TXT_RISK_BLOCKED: '文字描述含有违规内容，请修改后重试',
  gen_reason_REF_RISK_BLOCKED: '参考图含有违规内容，请更换后重试',
  gen_reason_IMG_RISK_BLOCKED: '生成图片含有违规内容，已被系统拦截',
  gen_reason_TASK_CREATE_FAILED: '任务创建失败，请稍后重试',
  gen_reason_QUEUE_TIMEOUT: '排队超时，请稍后重试',
  gen_reason_MODEL_ERROR: 'AI 模型异常，请稍后重试',
  gen_reason_AUDIT_TIMEOUT: '审核超时，请稍后重试',
  gen_reason_AUDIT_ERROR: '审核服务异常，请稍后重试',
  gen_reason_COMPENSATED_CLOSED: '因异常已退还积分，请重新生成',
  gen_reason_REFERENCE_IMAGE_DOWNLOAD_FAILED: '参考图片读取失败，请重新上传图片后再试',
  gen_reason_PROVIDER_BAD_REQUEST: 'AI 模型暂时无法处理该请求，请调整描述或图片后重试',
  gen_reason_PROVIDER_RATE_LIMITED: 'AI 模型繁忙或额度受限，请稍后重试',
  gen_reason_PROVIDER_ERROR: 'AI 生图服务暂时不可用，请稍后重试',
  gen_reason_PROVIDER_TIMEOUT: 'AI 生图服务响应超时，请稍后重试',
  gen_reason_PROVIDER_CAPACITY: 'AI 生图服务繁忙，积分已退回，请稍后重新提交',
  gen_reason_PROVIDER_TEXT_POLICY_REJECTED: '文字描述触发内容策略限制，请修改描述后重试',
  gen_reason_PROVIDER_SAFETY_BLOCKED: '输入或生成图片触发内容策略限制，积分已退回',
  gen_reason_PROVIDER_AUTH_FAILED: 'AI 服务配置异常，积分已退回，请稍后再试',
  gen_reason_PROVIDER_INVALID_REQUEST: '当前请求参数无法处理，积分已退回，请调整后重试',
  gen_reason_PROVIDER_OUTCOME_UNKNOWN: 'AI 服务结果仍在核对中，请勿重复提交',
  gen_reason_OUTPUT_STORAGE_FAILED: '图片保存失败，积分已退回，请重新提交',
  gen_reason_OUTPUT_QUALITY_FAILED: '图片质量检查未通过，积分已退回，请重新提交',
  gen_reason_TASK_TIMEOUT: '任务处理超时，积分已退回，请重新提交',
  gen_reason_RULE_BLOCKED: '文字描述触发内容规则限制，请修改后重试',
  gen_reason_SAFE_001: '安全审核服务暂时不可用，积分已退回，请稍后再试',
  gen_reason_SAFE_002: '图片格式或内容无法审核，请更换图片后重试',
  gen_reason_GENERATION_FAILED: '生成失败，请稍后重试',
  gen_reason_CONFIG_ERROR: '生图配置异常，请联系客服处理',
  gen_reason_default: '请稍后重试',

  gen_modifyPrompt: '修改描述',
  gen_tryAgain: '重试',
  result_nextTitle: '继续创作',
  result_nextDesc: '保存结果后，也可以继续修改或生成更多版本',
  result_addedHistory: '已入历史',
  result_continueEdit: '继续修改',
  result_regenerateFour: '重新生成4张',
  result_changeStyle: '换风格',
  result_addFavorite: '收藏',
  result_favorited: '已收藏',

  // Tool guidance
  tool_before: 'Before',
  tool_after: 'After',
  tool_inputRequirement: '输入要求',
  tool_expectedResult: '结果预期',
  tool_ifFails: '效果不好时',

  // Profile
  profile_title: '我的',
  profile_loginTitle: '登录后查看个人中心',
  profile_loginDesc: '登录即可查看积分、会员状态\n和历史生成记录',
  profile_loginBtn: '立即登录',
  profile_menu: '个人中心',
  profile_history: '生成记录',
  profile_points: '积分说明',
  profile_currentPoints: '当前',
  profile_membership: '会员中心',
  profile_membershipDesc: '开通享更多权益',
  profile_vipMember: 'VIP 会员',
  profile_settings: '设置',
  profile_contact: '联系客服',
  profile_agreement: '用户协议',
  profile_privacy: '隐私政策',
  profile_version: 'NanoImage2 v1.0.0',
  profile_pointsBalance: '积分余额',
  profile_generateTimes: '可生成次数',
  profile_historyCount: '生成记录',
  profile_openMembership: '开通会员',
  profile_favorites: '收藏',
  profile_noFavorites: '还没有收藏',
  profile_noFavoritesDesc: '长按作品可收藏到这里',
  profile_noHistory: '还没有生成记录',
  profile_noHistoryDesc: '去试试 AI 生图吧',
  profile_goGenerate: '立即生图',
  profile_continueCreating: '继续创作',
  profile_regenerate: '再次生成',
  profile_pointsTitle: '积分说明',
  profile_pointsLog: '积分流水',
  profile_contactTitle: '联系客服',
  profile_emailService: '邮件客服',
  profile_phoneService: '电话客服',
  profile_loading: '加载中...',
  profile_loadMore: '加载更多',

  // Profile Edit
  profile_edit_title: '编辑资料',
  profile_edit_avatar: '头像',
  profile_edit_tapToChange: '点击更换头像',
  profile_edit_nickname: '昵称',
  profile_edit_nicknamePlaceholder: '请输入昵称（1-20字）',
  profile_edit_save: '保存',
  profile_edit_saving: '保存中…',
  profile_edit_saveSuccess: '保存成功',
  profile_edit_saveFail: '保存失败，请稍后重试',
  profile_edit_avatarUploadFail: '头像上传失败，请重试',

  // Membership header & VIP view
  member_headerDesc: '高清生图 · 专属风格 · 优先出图',
  member_remainPoints: '剩余积分',
  member_remainDays: '剩余天数',
  member_autoRenew: '自动',
  member_cancelledRenew: '已取消',
  member_renewing: '续费中',
  member_notRenewing: '不续费',
  member_unlockedBenefits: '已解锁权益',
  member_monthlyUsage: '本月使用情况',
  member_unlimited: '无限制',
  member_renewPlan: '续费套餐',
  member_selectedPlanBenefits: '所选套餐权益',
  member_firstPurchaseGift: '首次开通赠送 {{points}} 积分',
  member_purchaseGift: '购买赠送 {{points}} 积分',
  member_valueTitle: '积分和 VIP 怎么配合',
  member_valueDesc: '积分用于每次生成，VIP 解锁更好的生成体验',
  member_valueFreeTitle: '免费体验',
  member_valueFreeDesc: '可用赠送积分先试核心功能',
  member_valueCreditsTitle: '积分消耗',
  member_valueCreditsDesc: '不同工具按次扣积分，失败会按规则兜底',
  member_valueVipTitle: 'VIP 权益',
  member_valueVipDesc: '高清无水印、优先队列、专属风格和更多赠送积分',

  // Membership
  member_title: '开通会员',
  member_subtitle: '解锁全部 AI 生图权益',
  member_currentPoints: '当前积分：',
  member_benefits: '会员专属权益',
  member_selectPlan: '选择套餐',
  member_perMonth: '/月',
  member_giftPoints: '赠',
  member_giftPointsUnit: '积分',
  member_selected: '已选择',
  member_openNow: '立即开通',
  member_agreePrefix: '开通即同意',
  member_memberAgreement: '《会员服务协议》',
  member_and: '和',
  member_autoRenewAgreement: '《自动续费协议》',
  member_successTitle: '开通成功！',
  member_successPlan: '已选择',
  member_successPlanSuffix: '套餐',
  member_successPoints: '赠送',
  member_successPointsSuffix: '积分 已到账',
  member_startCreate: '开始创作',
  member_agreeBtn: '我已阅读并同意',
  member_vipStatus: '闪绘 VIP 会员',
  member_vipExpire: '有效期至',
  member_vipActive: '已激活',
  member_manageSub: '管理订阅',
  member_manageUnavailable: '暂时无法打开 Apple 订阅管理，请稍后重试',
  member_renew: '续费会员',
  member_cancelAutoRenew: '取消自动续费',
  member_cancelConfirm: '确认取消自动续费？',
  member_cancelDesc: '取消后当前周期内权益仍可使用，到期不再续费。',
  member_cancelBtn: '确认取消',
  member_enableAutoRenew: '开启自动续费',
  member_keepRenew: '再想想',
  member_hdUnlocked: '高清下载已解锁',
  member_styleUnlocked: '全部风格已解锁',
  member_priorityUnlocked: '优先生成已解锁',
  member_processing: '处理中…',
  member_restorePurchases: '恢复购买',
  member_restoringPurchases: '正在恢复…',
  member_restoreSuccess: '购买已恢复',
  member_restoreNone: '没有找到可恢复的购买',
  member_restorePartial: '部分购买已恢复，其余项目请稍后重试',
  member_restoreFailed: '恢复购买失败，请稍后重试',
  member_syncAppStore: '从 App Store 重新同步',
  member_syncAppStoreHint: '仍未找到购买？重新同步可能需要验证 Apple 账户，但不会产生新的扣款。',
  member_packagesLoading: '正在加载套餐…',
  member_packagesLoadFailed: '套餐加载失败，请检查网络后重试',
  member_storePriceLoading: '正在获取 App Store 价格…',
  member_storePriceFailed: 'App Store 价格获取失败，购买已暂时停用',
  member_retry: '重新加载',
  member_storeProductUnavailable: '商品配置暂不可用，请稍后重试',
  member_payFailed: '支付失败，正在确认订单状态…',
  member_payCancelled: '已取消购买，未产生扣款',
  member_payPendingApple: '购买等待 Apple 确认，确认后将自动恢复权益',
  member_payConfirming: '购买可能已完成，正在确认权益，请勿重复购买',
  member_paySuccessMsg: '支付成功！欢迎加入会员',
  member_payIncomplete: '支付未完成，请重试',
  member_payRepairing: '已支付，权益生效或自动修复中，请稍候',
  member_payPendingRecovery: '上一笔订单仍在确认，请勿重复下单',
  member_cancelFailed: '取消失败，请重试',
  member_enableAutoRenewSuccess: '已开启自动续费',
  member_enableAutoRenewFail: '开启自动续费失败，请重试',
  member_activeTitle: '会员有效中',
  member_expireAt: '有效期至 ',
  vipNotice_title: '会员状态提醒',
  vipNotice_fixed_term_expiring: '您的会员还有 {{days}} 天到期（有效期至 {{date}}）。',
  vipNotice_auto_renew_scheduled: '连续包月预计于 {{renewalDate}} 由 Apple 自动续费。',
  vipNotice_auto_renew_disabled_expiring: '自动续费已关闭，会员还有 {{days}} 天到期。',
  vipNotice_billing_retry: 'Apple 正在重试续费，请检查付款方式以免会员权益中断。',
  vipNotice_grace: '续费暂未成功，当前处于宽限期，请尽快检查 Apple 付款方式。',
  vipNotice_expired: '会员已到期，当前已恢复为普通用户权益。',
  vipNotice_none: '',
  vipNotice_viewMembership: '查看会员详情',
  vipNotice_dismiss: '今日不再提示',
  member_autoRenewLabel: '· 自动续费',
  member_recommended: '推荐',
  member_loginTitle: '登录后开通会员',
  member_loginDesc: '登录即可查看会员权益、积分余额\n和开通会员专属服务',
  member_loginBtn: '立即登录',
  member_perYear: '/年',
  member_perQuarter: '/季',
  member_onlyPerDay: '仅{{currency}}{{price}}/天',
  member_save: '省{{currency}}{{amount}}',
  member_neverExpires: '永久有效',
  member_daysUnit: '天',
  member_renewAction: '续费',
  member_exclusiveBenefits: '专属权益',

  // Settings
  settings_title: '设置',
  settings_account: '账号',
  settings_accountSecurity: '账号与安全',
  settings_notifications: '消息通知',
  settings_general: '通用',
  settings_clearCache: '清除缓存',
  settings_language: '语言设置',
  settings_about: '关于',
  settings_agreement: '用户协议',
  settings_privacy: '隐私政策',
  settings_aboutUs: '关于我们',
  settings_rateUs: '给我们评分',
  settings_logout: '退出登录',
  settings_logoutConfirm: '确认退出登录？',
  settings_logoutDesc: '退出后需要重新登录才能使用 AI 生图功能',
  settings_logoutConfirmBtn: '确认退出',
  settings_cancel: '取消',
  settings_clearCacheTitle: '清除缓存',
  settings_clearCacheDesc: '将清除',
  settings_clearCacheDesc2: '的缓存数据，不影响账号信息',
  settings_clearCacheConfirm: '确认清除',
  settings_clearCacheSuccess: '清除成功',
  settings_clearCacheSuccessDesc: '已释放 12.3 MB 空间',
  settings_cacheFreedDesc: '已释放 {{size}} 空间',
  settings_aboutTitle: '关于我们',
  settings_version: '版本 v1.0.0',
  settings_aboutDesc: 'NanoImage2 是一款 AI 图片生成应用。围绕文字描述、参考图与风格模板三种输入方式，结合多模型路由与清晰度档位，将一次创作意图转换为可保留、可重生成的画面结果。我们持续优化提示词扩写、模型调度与生成质量，专注让每一次描述更贴近你想要的画面。',
  settings_copyright: '© 2026 NanoImage2. All rights reserved.',
  settings_phone: '手机号',
  settings_email: '邮箱',
  settings_cancelSubSuccess: '已提交取消申请。请前往 iOS 系统设置 > Apple ID > 订阅 关闭自动续费',
  settings_operateFailed: '操作失败，请稍后重试',
  settings_cacheCalculating: '计算中...',
  settings_cacheLessThan1MB: '< 1 MB',
  profile_changeAvatar: '更换头像',
  profile_chooseFromAlbum: '从相册选择',
  profile_takePhoto: '拍照',
  profile_supportHours: '7×24 小时全天候服务',
  gen_referenceUploaded: '参考图已上传',
  profile_workTime: '周一至周五 10:00 - 18:00',
  settings_verified: '已验证',
  settings_loading: '加载中…',
  settings_loginAccount: '登录账号',
  settings_primaryLogin: '主登录方式',
  settings_loginImmutableHint: '登录方式创建后不可切换，也不会与其他手机号、邮箱、Google 或 Apple 账号自动合并。',
  settings_contactInfo: '联系资料',
  settings_contactNotLoginHint: '绑定的手机号和邮箱仅用于联系，不能用于登录当前账号。',
  settings_notBound: '未绑定',
  settings_bindContact: '绑定',
  settings_changeContact: '更换',
  settings_removeContact: '解绑',
  settings_contactRemoveConfirm: '确认解绑这项联系资料？解绑不会改变登录账号。',
  settings_bindPhone: '绑定手机号',
  settings_bindEmail: '绑定邮箱',
  settings_phonePlaceholder: '请输入手机号',
  settings_emailPlaceholder: '请输入邮箱',
  settings_codePlaceholder: '验证码',
  settings_sendCode: '发送验证码',
  settings_resendCode: '重新发送',
  settings_confirmBind: '确认绑定',
  settings_providerPhone: '手机号验证码',
  settings_providerEmail: '邮箱验证码',
  settings_securityLoadFailed: '账号安全信息加载失败',
  settings_securityOperationFailed: '操作失败，请稍后重试',
  settings_deleteFailed: '账号注销失败，账号和本机登录状态均未改变，请稍后重试。',
  settings_deleteAccount: '注销账号',
  settings_deleteAccountTitle: '注销账号',
  settings_deleteAccountDesc: '注销账号后，以下数据将被永久删除：',
  settings_deleteItem1: '账号信息及登录凭证',
  settings_deleteItem2: '所有历史生成记录',
  settings_deleteItem3: '积分余额及会员权益',
  settings_deleteWarning: '此操作不可恢复，请谨慎操作。',
  settings_continueDelete: '继续注销',
  settings_confirmDelete: '确认注销',
  settings_confirmDeleteTitle: '确认注销',
  settings_confirmDeleteDesc: '请输入「确认注销」以完成操作',
  settings_confirmDeletePlaceholder: '确认注销',
  settings_back: '返回',
  settings_notifyGenerateDone: '生成完成提醒',
  settings_notifyGenerateDoneDesc: '图片生成完成后推送通知',
  settings_notifyActivity: '活动通知',
  settings_notifyActivityDesc: '优惠活动、新功能上线提醒',
  settings_notifySystem: '系统消息',
  settings_notifySystemDesc: '账号安全、系统维护通知',
  settings_languageTitle: '语言设置',
  settings_currentLang: '当前使用',
  settings_langZh: '简体中文',
  settings_langEn: 'English',
  settings_rateTitle: '给我们评分',
  settings_rateDesc: '您的评价能帮助我们做得更好',
  settings_rateSubmit: '提交评价',
  settings_rateThanks: '感谢评价',
  settings_rateThanksDesc: '您的反馈是我们进步的动力',
  settings_footerText: 'NanoImage2 v1.0.0 · 粤ICP备XXXXXXXX号',
  settings_simplifiedChinese: '简体中文',
  settings_comingSoon: '即将上线',
  settings_langOnlyChinese: '目前仅支持简体中文，更多语言敬请期待',
  settings_loginTitle: '登录后查看设置',
  settings_loginDesc: '登录即可管理账号、查看通知设置\n和使用更多个性化功能',
  settings_loginBtn: '立即登录',

  // Templates
  template_exampleCount: '{{count}} 张示例',
  tpl_female_portrait: '女生写真',
  tpl_male_portrait: '男生写真',
  tpl_anime_avatar: '动漫头像',
  tpl_chinese_portrait: '国风人像',
  tpl_poster: '海报封面',

  // Styles
  sty_ccd: 'CCD 相机',
  sty_film: '胶片风',
  sty_chinese: '国风',
  sty_3d_cartoon: '3D 卡通',
  sty_comic: '漫画',
  sty_dunhuang: '敦煌壁画',

  // Inspiration hints
  insp_female_portrait: '女生写真',
  insp_female_portrait_sub: '精致妆容·柔和光线',
  insp_chinese_portrait: '国风人像',
  insp_chinese_portrait_sub: '汉服·水墨意境',
  insp_anime_avatar: '动漫头像',
  insp_anime_avatar_sub: '二次元·可爱风',
  insp_poster: '创意海报',
  insp_poster_sub: '渐变·视觉冲击',

  // Showcase labels
  showcase_ccd: 'CCD 相机',
  showcase_anime: '动漫头像',
  showcase_chinese: '国风人像',
  showcase_3d: '3D 卡通',
  showcase_film: '胶片风',
  showcase_poster: '海报封面',
  showcase_comic: '漫画',

  // Membership benefits
  benefit_hd_title: '高清无水印下载',
  benefit_hd_desc: '生成图片高清无水印，随时保存',
  benefit_more_title: '更多生成次数',
  benefit_more_desc: '每月大额积分赠送，畅快创作',
  benefit_style_title: '解锁高级风格',
  benefit_style_desc: '敦煌壁画等专属风格任意使用',
  benefit_speed_title: '生成加速',
  benefit_speed_desc: '优先队列，更快出图',

  // Membership packages
  pkg_monthly_auto_name: '连续包月',
  pkg_monthly_auto_desc: '自动续费，随时取消',
  pkg_monthly_auto_tag: '推荐',
  pkg_monthly_auto_feature: '无限高清 · 专属风格 · 每日10次AI · 优先生成',
  pkg_monthly_name: '月卡',
  pkg_monthly_desc: '一次性购买，30天有效',
  pkg_monthly_feature: '无限高清 · 专属风格 · 优先生成',

  // New user gift
  newUserGift_desc: '注册即送 {{giftPoints}} 积分，可生成 {{maxImages}} 张图片',

  // Points rules
  points_rule_register: '注册奖励',
  points_rule_dailyLogin: '每日登录',
  points_rule_generate: '每次生图',

  // Points log descriptions
  pointsLog_generate: 'AI 生图消耗',
  pointsLog_dailyLogin: '每日登录奖励',
  pointsLog_register: '新用户注册奖励',
  pointsLog_refundGenFail: '生成失败退款',
  pointsLog_vipGift: 'VIP 赠送积分',
  pointsLog_promptExpandCost: '提示词扩展消耗',

  // Login
  login_title: 'NanoImage2',
  login_subtitle: 'AI 生图',
  login_slogan1: '输入一句话',
  login_slogan2: '立即生成图片',
  login_phoneLabel: '手机号',
  login_phonePlaceholder: '请输入手机号',
  login_codeLabel: '验证码',
  login_codePlaceholder: '请输入验证码',
  login_sendCode: '获取验证码',
  login_sending: '发送中...',
  login_resend: '重新发送',
  login_agreePrefix: '登录即代表同意',
  login_userAgreement: '《用户协议》',
  login_and: '和',
  login_privacyPolicy: '《隐私政策》',
  login_loginBtn: '登录 / 注册',
  login_loggingIn: '登录中...',
  login_loginSuccess: '立即登录',
  login_footerDesc: '未注册手机号将自动创建账号',
  login_switchEmail: '使用邮箱登录',
  login_switchPhone: '使用手机号登录',
  login_emailLabel: '邮箱',
  login_emailPlaceholder: '请输入邮箱地址',
  login_emailCodeLabel: '验证码',
  login_emailCodePlaceholder: '请输入邮箱验证码',
  login_sendEmailCode: '发送验证码',
  login_emailLoginBtn: '邮箱登录',
  login_emailFooterDesc: '未注册邮箱将自动创建账号',
  login_errPhone: '请输入正确的手机号',
  login_errCode: '请输入6位验证码',
  login_errAgree: '请先阅读并同意用户协议',
  login_errEmail: '请输入正确的邮箱地址',
  login_errEmailCode: '请输入6位验证码',
  login_errSmsFail: '短信服务暂时不可用，请稍后再试',
  login_errSendFail: '发送失败，请稍后重试',
  login_errLoginFail: '登录失败，请稍后重试',
  login_errChallenge: '请先获取验证码',
  login_errProviderUnavailable: '该登录方式暂时不可用，请稍后再试',
  login_or: '或',
  login_google: '使用 Google 登录',
  login_apple: '通过 Apple 登录',
  login_socialLoading: '正在登录...',
  login_independentAccounts: '不同登录方式对应不同账号，数据不互通',

  // Profile edit entry
  profile_editProfile: '编辑资料',
  profile_changeNickname: '修改昵称',

  // Generate — ConfigBar
  gen_creationSettings: '创作设定',
  gen_outputSettings: '输出设置',
  gen_referenceShort: '参考图',
  gen_styleShort: '风格',
  gen_templateShort: '模板',
  gen_modelFallback: '模型',
  gen_modelShort: '模型',
  gen_noAvailableModels: '无可用模型',
  gen_ratioFallback: '比例',
  gen_qualityFallback: '画质',
  gen_noAvailableQualities: '无可用画质',
  gen_countFallback: '张数',
  gen_countSingle: '单张',
  gen_selectedConfig: '当前配置',
  gen_seeMore: '查看更多',
  gen_notAdded: '未添加',
  gen_notSelected: '未选择',
  gen_standardQuality: '标准',
  gen_qualityHd: '高清',
  gen_qualityUltra: '超高清',
  gen_recentUsage: '最近使用',
  gen_noTemplates: '暂无模板',
  gen_all: '全部',
  gen_estimateTime: '预计约 30 秒',
  reference_image_alt: '参考图',

  // VIP upgrade sheet
  vip_unlock_ultra_title: '解锁 VIP 特权',
  vip_unlock_ultra_desc: '升级会员，享受全部专属功能',
  vip_unlock_benefit1: '解锁 HD/Ultra 超清画质',
  vip_unlock_benefit2: '解锁 VIP 专属风格',
  vip_open_now: '立即开通',
  vip_not_now: '暂不开通',

  // Share sheet
  share_moments: '朋友圈',
  share_wechat: '微信',
  share_copyLink: '复制链接',
  share_saveImage: '保存图片',
  share_cancel: '取消',
  share_linkCopied: '链接已复制',
  gen_saving: '保存中...',
  gen_savedToAlbum: '已保存到相册',
  gen_saveFailed: '保存失败，请重试',

  // Profile — preview modal actions
  profile_reuseParams: '参数复用',
  profile_collect: '收藏',
  profile_favorited: '已收藏',
  profile_share: '分享',
  profile_save: '保存',
  profile_delete: '删除',
  profile_deleteConfirm: '确认删除这张图片？',
  profile_deleteFailed: '删除失败，请重试',
  profile_promptCopied: '已复制',

  // BottomNav — gallery tab (v2.0)
  nav_gallery: '广场',

  // Gallery page (v2.0)
  gallery_title: '作品广场',
  gallery_filter_all: '全部',
  gallery_filter_text2img: '文生图',
  gallery_filter_img2img: '图生图',
  gallery_filter_edit: '修图改图',
  gallery_filter_restore: '画质修复',
  gallery_filter_tryon: '模特试衣',
  gallery_totalWorks: '作品',
  gallery_hotToday: '今日热度',
  gallery_empty: '暂无作品',
  gallery_loadMoreHint: '持续加载更多社区创作...',
  gallery_loading: '加载中...',
  gallery_loadMore: '加载更多',
  gallery_noMore: '已显示全部作品',
  gallery_featured: '精选',
  gallery_usePrompt: '使用描述',
  gallery_similarCreate: '同款创作',

  // Home — v2.0 new sections
  home_aiTools: 'AI 创作工具',
  home_heroTitle: '释放你的想象力',
  home_heroSubtitle: 'AI 驱动的全能图像创作平台',
  home_startCreate: '开始创作',
  home_exploreMore: '探索更多',
  home_todayGenerated: '今日生成',
  home_onlineCreators: '在线创作',
  home_totalWorks: '作品总数',
  home_inspirationBanner: '灵感画廊',
  home_inspirationBannerDesc: '探索社区创作者的无限想象力',
  home_enterGallery: '进入广场',
  home_featuredWorks: '精选作品',
  home_modelEntry_title: '最火模型推荐',
  home_modelEntry_new: '新上线',
  home_nanoBanana_desc: '快速创意出图 · 灵感即刻呈现',
  home_chatgptImage_desc: '写实精准生成 · GPT 强大驱动',

  // Home — AI tool cards (v2.0)
  tool_text2img: '文生图',
  tool_text2img_desc: '输入描述，AI 从零创作',
  tool_img2img: '图生图',
  tool_img2img_desc: '上传参考，基于参考创作',
  tool_edit: '修图改图',
  tool_edit_desc: '上传图片，描述修改内容',
  tool_restore: '画质修复',
  tool_restore_desc: '模糊老照片一键高清',
  tool_tryon: '模特试衣',
  tool_tryon_desc: '人物照+服装照生成模特效果',
  tool_more: '更多功能',
  tool_hot: '热门',

  // Generate — mode selector (v2.0)
  mode_text2img: 'AI生图',
  mode_img2img: '图生图',
  mode_edit: '图片编辑',
  mode_restore: '照片修复',
  mode_tryon: '虚拟试穿',

  // Generate — gen_mode aliases (v2.0)
  gen_mode_text2img: '文生图',
  gen_mode_img2img: '图生图',
  gen_mode_edit: '图片编辑',
  gen_mode_restore: '照片修复',
  gen_mode_tryon: '虚拟试穿',

  // Generate — img2img / upload labels (v2.0)
  img2img_uploadReference: '上传参考图片',
  img2img_clickUpload: '点击上传参考图，可多选',
  img2img_supportFormat: '仅支持 JPG、PNG 图片，最多 6 张',
  img2img_referenceCount: '已添加 {{count}}/{{max}} 张参考图',
  img2img_addMore: '继续添加',
  img2img_imageLimit: '最多上传 {{count}} 张参考图',
  img2img_onlyJpgPng: '图生图仅支持 JPG、PNG 图片',
  img2img_describeChange: '描述你想要的改变',
  img2img_placeholder: '描述你希望基于参考图生成的内容，例如：把背景换成海边日落...',

  // Generate — required field marker
  gen_required: '必填',

  // Generate — chat interface (v2.0)
  chat_regenerating: '正在重新生成...',
  chat_generationPendingTip: '您的图片正在生成，稍后也可以在我的生成记录里面查看',
  chat_recentMemoryTitle: '仅展示最近 3 条创作',
  chat_recentMemoryDesc: '全部图片可在“我的-生成记录”查看',
  chat_viewAllHistory: '查看全部',
  chat_insp1: '赛博朋克风格女孩',
  chat_insp2: '国风水墨山水画',
  chat_insp3: '可爱Q版动漫角色',
  chat_insp4: '未来科幻城市',
  chat_insp5: '日式治愈插画',
  chat_insp6: '梦幻星空场景',
  chat_welcomeCardTitle: '您好！我是AI画师',
  chat_welcomeCardLine1: '告诉我你想要的画面，',
  chat_welcomeCardLine2: '我会帮你创作出惊艳的作品',
  chat_aiAssistant: 'AI绘画助手',
  chat_editPlaceholder: '描述你想怎么修改这些图片，例如：把背景换成海边日落，保留人物',
  chat_defaultEditPrompt: '根据上传图片进行创作和修改',
  chat_imageLimit: '最多可上传 {{count}} 张参考图',
  chat_voiceStart: '语音输入',
  chat_voiceStop: '停止语音输入',
  chat_voiceListening: '正在聆听...',
  chat_voiceListeningWithText: '正在识别：{{text}}',
  chat_voiceUnsupported: '当前环境不支持语音输入',
  chat_voicePermissionDenied: '请允许麦克风权限后再试',
  chat_voiceNoSpeech: '没有识别到语音，请重试',
  chat_voiceFailed: '语音识别失败，请重试',
  chat_voiceLang: 'zh-CN',
  profile_filterStatusAll: '全部',
  profile_filterStatusActive: '进行中',
  profile_filterStatusSuccess: '成功',
  profile_filterStatusIncomplete: '未完成',
  profile_filterButton: '筛选',
  profile_filterTitle: '筛选生成记录',
  profile_filterClose: '关闭筛选',
  profile_filterModel: '模型',
  profile_filterAllModels: '全部模型',
  profile_filterPeriod: '时间',
  profile_filterAllTime: '全部时间',
  profile_filterToday: '今天',
  profile_filter7Days: '近 7 天',
  profile_filter30Days: '近 30 天',
  profile_filterOrder: '排序',
  profile_filterNewest: '最新优先',
  profile_filterOldest: '最早优先',
  profile_filterReset: '重置',
  profile_filterViewResults: '查看结果',
  profile_filterLoadFailed: '生成记录加载失败',
  profile_filterLoadFailedDesc: '请检查网络后重试',
  profile_filterRetry: '重新加载',
  profile_filterNoMatches: '没有符合条件的生成记录',
  profile_filterNoMatchesDesc: '调整筛选条件后再试试',
  profile_filterClear: '清除筛选',
  gen_refreshInspiration: '换一换',
  gen_placeholderWithExample: '描述你想要的画面，越详细越好哦～\n例如：一位穿着汉服的女子站在樱花树下，花瓣飘落，梦幻光影，超高清画质',

  // More AI Tools page (v2.0)
  extool_title: '更多AI工具',
  extool_subtitle: '探索更多强大的AI图像处理功能，让你的创作更加自由',
  extool_comingSoon: '即将上线',
  extool_bgReplace: '替换背景',
  extool_bgReplace_desc: '智能识别主体，一键替换图片背景',
  extool_bgClean: '背景净化',
  extool_bgClean_desc: '清除背景杂乱元素，让画面更干净',
  extool_clothExtract: '服装提取',
  extool_clothExtract_desc: '从照片中精准提取服装款式',
  extool_outpaint: 'AI扩图',
  extool_outpaint_desc: '智能扩展图片边界，补全画面内容',
  extool_watermarkRemove: '去水印',
  extool_watermarkRemove_desc: 'AI智能去除图片水印和杂物',
  extool_colorize: '老照片上色',
  extool_colorize_desc: '为黑白老照片智能上色，重现色彩',
  extool_objectRemove: '人物消除',
  extool_objectRemove_desc: '一键移除照片中的路人或多余物体',
  extool_styleTransfer: '风格迁移',
  extool_styleTransfer_desc: '将图片转换为任意艺术风格',

  // Tool pages — bg-replace (v2.0)
  bg_replace_uploadLabel: '上传图片',
  bg_replace_uploadPlaceholder: '点击上传图片',
  bg_replace_promptLabel: '新背景描述',
  bg_replace_promptPlaceholder: '描述你想要的背景，例如：樱花盛开的公园、海边日落、城市夜景...',
  bg_replace_promptTip: '越详细的描述效果越好',
  bg_replace_inputRequirement: '上传主体清晰、边缘完整的图片，人物或商品不要被大面积遮挡。',
  bg_replace_expectedResult: 'AI 会保留主体，把背景替换成你描述的场景，并尽量匹配光影。',
  bg_replace_fallbackTip: '如果主体边缘不自然，请换背景更干净的原图，或把背景描述写得更具体。',
  bg_replace_beforeHint: '原始背景',
  bg_replace_afterHint: '新背景',

  // Tool pages — bg-clean (v2.0)
  bg_clean_uploadLabel: '上传图片',
  bg_clean_uploadPlaceholder: '点击上传图片',
  bg_clean_defaultPrompt: '清除背景',

  // Tool pages — cloth-extract (v2.0)
  cloth_extract_sourceLabel: '上传含服装的图片',
  cloth_extract_sourcePlaceholder: '点击上传服装来源图',
  cloth_extract_defaultPrompt: '服装提取',
  cloth_extract_inputRequirement: '上传一张服装主体清晰、轮廓完整、遮挡较少的图片。',
  cloth_extract_expectedResult: 'AI 会提取单件服装并生成居中的 1:1 独立服装图。',
  cloth_extract_fallbackTip: '如果服装轮廓缺失，请换用背景更干净、服装更完整的来源图。',
  cloth_extract_beforeHint: '服装来源图',
  cloth_extract_afterHint: '独立服装图',

  // Tool pages — outpaint (v2.0)
  outpaint_uploadLabel: '上传图片',
  outpaint_uploadPlaceholder: '点击上传图片',
  outpaint_directionLabel: '选择扩展方向',
  outpaint_top: '向上',
  outpaint_bottom: '向下',
  outpaint_left: '向左',
  outpaint_right: '向右',
  outpaint_defaultPrompt: '智能扩展图片',

  // Tool pages — watermark-remove (v2.0)
  watermark_remove_uploadLabel: '上传图片',
  watermark_remove_uploadPlaceholder: '点击上传图片',
  watermark_remove_defaultPrompt: '去除水印',
  watermark_remove_inputRequirement: '上传水印清楚、主体完整的图片，避免水印覆盖关键人脸或文字。',
  watermark_remove_expectedResult: 'AI 会重建水印区域，让背景和纹理尽量自然衔接。',
  watermark_remove_fallbackTip: '如果修复痕迹明显，请裁剪到水印区域更清晰的版本，或分区域多次处理。',
  watermark_remove_beforeHint: '有水印',
  watermark_remove_afterHint: '干净图',

  // Tool pages — colorize (v2.0)
  colorize_uploadLabel: '上传老照片',
  colorize_uploadPlaceholder: '点击上传老照片',
  colorize_strengthLabel: '上色强度',
  colorize_gentle: '自然',
  colorize_strong: '浓郁',
  colorize_currentStrength: '当前强度',
  colorize_defaultPrompt: '老照片上色',

  // Tool pages — object-remove (v2.0)
  object_remove_uploadLabel: '上传图片',
  object_remove_uploadPlaceholder: '点击上传图片',
  object_remove_descLabel: '描述要移除的内容',
  object_remove_descPlaceholder: '描述你想移除的物体，例如：左下角的路人、背景中的汽车...',
  object_remove_descTip: '描述越具体，移除效果越好',
  object_remove_defaultPrompt: '移除指定物体',

  // Tool pages — style-transfer (v2.0)
  style_transfer_uploadLabel: '上传图片',
  style_transfer_uploadPlaceholder: '点击上传图片',
  style_transfer_styleLabel: '选择艺术风格',
  style_transfer_defaultPrompt: '风格迁移',

  // Generate — edit mode labels
  edit_uploadOriginal: '上传原图',
  edit_tapToMarkArea: '已上传，请描述你想修改的内容',
  edit_clickUpload: '点击上传原图',
  edit_supportFormat: '支持 JPG、PNG 图片',
  edit_describeEdit: '描述修改内容',
  edit_placeholder: '描述你想修改的内容，例如：把背景换成樱花盛开的公园...',
  edit_aiSuggestion: 'AI建议',
  restore_uploadImage: '上传照片',
  restore_previewMode: '已上传，将进行画质修复',
  restore_clickUpload: '点击上传照片',
  restore_supportFormat: '支持 JPG、PNG 图片',
  restore_strength: '修复力度',
  restore_gentle: '温和',
  restore_strong: '强力',
  tryon_uploadPerson: '上传人物照',
  tryon_uploadClothing: '上传服装照',
  tryon_personTip: '上传清晰正面照',
  tryon_clothingTip: '上传完整服装照',
  tryon_selectPose: '选择姿势',
  tryon_pose_natural: '自然站立',
  tryon_pose_front: '正面朝前',
  tryon_pose_side: '侧身展示',
  tryon_pose_cross: '交叉双臂',
};

export default zh;
